// extracted by mini-css-extract-plugin
export default {"root":"TaskReload_root__2JQXj","text":"TaskReload_text__Z3qLP"};